import { auth, db } from '@/config/firebase.js'
import { doc, getDoc } from "firebase/firestore/lite"
import {
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut
} from "firebase/auth";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';


class fireBaseService {



    showToastError(message) {
        toast.error(message);
    }
    showToastSuccess(message) {
        toast.success(message);
    }
    showToastInfo(message) {
        toast.info(message);
    }
    showToastWarn(message) {
        toast.warn(message);
    }

    async checkUserIsAdmin(uid) {
        const docRef = doc(db, "users", uid)
        const userDoc = await getDoc(docRef)
        if (userDoc.exists()) {
            const user = userDoc.data()
            if (user.isAdmin) {
                return user;
            }
        }
        return null
    }

    async login(email, password) {
        let userBack = null
        await signInWithEmailAndPassword(auth, email, password)
            .then(async (data) => {
                userBack = await this.checkUserIsAdmin(data.user.uid)
                if (userBack != null) {
                    this.showToastInfo('is admin')
                } else {
                    this.showToastError("Email or password was incorrect")
                }
            })
            .catch((error) => {
                switch (error.code) {
                    case "auth/invalid-email":
                        this.showToastError("Invalid email");
                        break;
                    case "auth/user-not-found":
                        this.showToastError("No account with that email was found");
                        break;
                    case "auth/wrong-password":
                        this.showToastError("Incorrect password");
                        break;
                }
            });
        console.log(` userback value  :: ${userBack}`)
        return userBack;
    }

    async logout() {
        let logout = false
        await signOut(auth).then(() => {
            logout = true
        }).catch((error) => {
            toast.error(error.message)
        });
        return logout
    }

    getActiveUserSession() {
        return new Promise((resolve) => {
            onAuthStateChanged(auth, async (user) => {
                if (user) {
                    const isAdmin = await this.checkUserIsAdmin(user.uid)
                    if (isAdmin != null) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                } else {
                    resolve(false)
                }
            })
        });
    }
}



export default new fireBaseService();